<form>
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
    <!-- Account Details -->
    <div class="col-span-1">
      <div class="bg-white border border-fff9f9 rounded-lg overflow-hidden">
        <div class="bg-fff9f9 p-2">
          <p class="text-base lg:text-lg font-semibold text-black text-center capitalize">Account Details</p>
        </div>
        <div class="p-1.5 lg:p-3 grid grid-cols-2 gap-2">
          <!-- Account Name -->
          <div class="col-span-2">
            <div class="relative">
              <input type="text" id="acc_user_acc" name="acc_user_acc" placeholder=" "
                [(ngModel)]="formData.acc_user_acc" required
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_user_acc"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Account
                Name</label>
            </div>
          </div>
          <!-- Firm Name -->
          <div class="col-span-1 ">
            <div class="relative">
              <select id="acc_firm_id" name="acc_firm_id" [(ngModel)]="formData.acc_firm_id" required
                class="block ps-1 pe-4.5 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" ">
                <option *ngIf="firms.length > 1" [value]="null" disabled>Select Firm</option>
                <option *ngFor="let firm of firms" [value]="firm.id">
                  {{ firm.name }}
                </option>
              </select>
              <label for="acc_firm_id"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1
           peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                Firm
              </label>
              <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                <svg width="8" height="4" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L2.85817 2.44986L5.71633 0H0Z" fill="#C19725" />
                </svg>
              </div>
            </div>
          </div>
          <!-- Account Type -->
          <div class="col-span-1 ">
            <div class="relative">
              <select id="selectedAccountType" name="selectedAccountType" [(ngModel)]="formData.selectedAccountType"
                required
                class="block ps-1 pe-4.5 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" ">
                <option value="" disabled hidden></option>
                <option *ngFor="let account of accountType" [value]="account">{{ account }}</option>
              </select>
              <label for="selectedAccountType"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1
           peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                Account Type
              </label>
              <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                <svg width="8" height="4" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L2.85817 2.44986L5.71633 0H0Z" fill="#C19725" />
                </svg>
              </div>
            </div>
          </div>
          <div class="col-span-2 grid grid-cols-2 sm:grid-cols-1 lg:grid-cols-3 gap-2">
            <div class="col-span-2 sm:col-span-1 lg:col-span-3">
              <p class="text-black font-medium text-[13px] sm:text-sm lg:text-[15px] capitalize my-2">Opening Balance
                Date
              </p>
            </div>
            <!-- Date -->
            <div class="col-span-1">
              <div class="relative">
                <input type="date" id="acc_cash_balance_date" name="acc_cash_balance_date" placeholder=" "
                  [(ngModel)]="formData.acc_cash_balance_date"
                  class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
                <label for="acc_cash_balance_date"
                  class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Date</label>
              </div>
            </div>
            <!-- Cash Balance -->
            <div class="col-span-1">
              <div class="relative">
                <input type="number" id="acc_cash_balance" name="acc_cash_balance" placeholder=" "
                  [(ngModel)]="formData.acc_cash_balance"
                  class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
                <label for="acc_cash_balance"
                  class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Cash
                  Balance</label>
              </div>
            </div>
            <!-- CR/DR -->
            <div class="col-span-1">
              <div class="relative">
                <!-- SELECT FIELD -->
                <select id="acc_cash_balance_crdr" name="acc_cash_balance_crdr"
                  [(ngModel)]="formData.acc_cash_balance_crdr" required
                  class="block ps-1 pe-4.5 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner">
                  <!-- placeholder option -->
                  <option value="" hidden></option>
                  <option *ngFor="let type of crdrTypes" [value]="type">
                    {{ type }}
                  </option>
                </select>
                <!-- FLOATING LABEL -->
                <label for="acc_cash_balance_crdr"
                  class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4">
                  CR / DR
                </label>

                <!-- DROPDOWN ICON -->
                <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                  <svg width="8" height="4" viewBox="0 0 6 3" fill="none">
                    <path d="M0 0L2.85817 2.44986L5.71633 0H0Z" fill="#C19725" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Account Information -->
    <div class="col-span-1">
      <div class="bg-white border border-efffed rounded-lg overflow-hidden">
        <div class="bg-efffed p-2">
          <p class="text-base lg:text-lg font-semibold text-black text-center capitalize">Account Information</p>
        </div>
        <div class="p-1.5 lg:p-3 grid grid-cols-2 lg:grid-cols-4 gap-2">
          <!-- Account Description -->
          <div class="col-span-2 lg:col-span-4">
            <div class="relative">
              <input type="text" id="acc_description" name="acc_description" placeholder=" "
                [(ngModel)]="formData.acc_description"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_description"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Account
                Description</label>
            </div>
          </div>
          <!-- Address -->
          <div class="col-span-2 lg:col-span-4">
            <div class="relative">
              <input type="text" id="acc_address" name="acc_address" placeholder=" " [(ngModel)]="formData.acc_address"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_address"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Address</label>
            </div>
          </div>
          <!-- Country -->
          <div class="col-span-1 ">
            <div class="relative">
              <select id="country_id" name="country_id" [(ngModel)]="formData.country_id" (change)="onCountryChange()"
                required
                class="block ps-1 pe-4.5 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" ">
                <option value="" disabled hidden></option>
                <option *ngFor="let country of countries" [value]="country.id">{{ country.name }}</option>
              </select>
              <label for="country_id"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1
           peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                Country
              </label>
              <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                <svg width="8" height="4" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L2.85817 2.44986L5.71633 0H0Z" fill="#C19725" />
                </svg>
              </div>
            </div>
          </div>
          <!-- State -->
          <div class="col-span-1 ">
            <div class="relative">
              <select id="state_id" name="state_id" [(ngModel)]="formData.state_id" (change)="onStateChange()" required
                class="block ps-1 pe-4.5 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" ">
                <option value="" disabled hidden></option>
                <option *ngFor="let state of states" [value]="state.id">{{ state.name }}</option>
              </select>
              <label for="state_id"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1
           peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                State
              </label>
              <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                <svg width="8" height="4" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L2.85817 2.44986L5.71633 0H0Z" fill="#C19725" />
                </svg>
              </div>
            </div>
          </div>
          <!-- City -->
          <div class="col-span-1 ">
            <div class="relative">
              <select id="city_id" name="city_id" [(ngModel)]="formData.city_id" required
                class="block ps-1 pe-4.5 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" ">
                <option value="" disabled hidden></option>
                <option *ngFor="let city of cities" [value]="city.id">{{ city.name }}</option>
              </select>
              <label for="city_id"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1
           peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                City
              </label>
              <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                <svg width="8" height="4" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L2.85817 2.44986L5.71633 0H0Z" fill="#C19725" />
                </svg>
              </div>
            </div>
          </div>
          <!-- Pincode -->
          <div class="col-span-1">
            <div class="relative">
              <input type="text" id="acc_pincode" name="acc_pincode" placeholder=" " [(ngModel)]="formData.acc_pincode"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_pincode"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Pincode</label>
            </div>
          </div>
          <!-- PAN /IT No. -->
          <div class="col-span-2 lg:col-span-4">
            <div class="relative">
              <input type="text" id="acc_pan_it_no" name="acc_pan_it_no" placeholder=" "
                [(ngModel)]="formData.acc_pan_it_no"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_pan_it_no"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">PAN
                /IT No.</label>
            </div>
          </div>
          <!-- Sales Tax No. -->
          <div class="col-span-2 lg:col-span-4">
            <div class="relative">
              <input type="text" id="acc_sales_tax_no" name="acc_sales_tax_no" placeholder=" "
                [(ngModel)]="formData.acc_sales_tax_no"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_sales_tax_no"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Sales
                Tax No.</label>
            </div>
          </div>
          <!-- CST No. -->
          <div class="col-span-2 lg:col-span-4">
            <div class="relative">
              <input type="text" id="acc_cst_no" name="acc_cst_no" placeholder=" " [(ngModel)]="formData.acc_cst_no"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_cst_no"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">CST
                No.</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Bank Details -->
    <div class="col-span-1">
      <div class="bg-white border border-ecefff rounded-lg overflow-hidden">
        <div class="bg-ecefff p-2">
          <p class="text-base lg:text-lg font-semibold text-black text-center capitalize">Bank Details</p>
        </div>
        <div class="p-1.5 lg:p-3 grid grid-cols-1 gap-2">
          <!-- Bank Account No. -->
          <div class="col-span-1">
            <div class="relative">
              <input type="text" id="acc_banc_acc_no" name="acc_banc_acc_no" placeholder=" "
                [(ngModel)]="formData.acc_banc_acc_no"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_banc_acc_no"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Bank
                Account No.</label>
            </div>
          </div>
          <!-- Branch Name -->
          <div class="col-span-1">
            <div class="relative">
              <input type="text" id="acc_branch_name" name="acc_branch_name" placeholder=" "
                [(ngModel)]="formData.acc_branch_name"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_branch_name"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Branch
                Name</label>
            </div>
          </div>
          <!-- BSR Code -->
          <div class="col-span-1">
            <div class="relative">
              <input type="text" id="acc_bsr_code" name="acc_bsr_code" placeholder=" "
                [(ngModel)]="formData.acc_bsr_code"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_bsr_code"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">BSR
                Code</label>
            </div>
          </div>
          <!-- IFS Code -->
          <div class="col-span-1">
            <div class="relative">
              <input type="text" id="acc_ifs_code" name="acc_ifs_code" placeholder=" "
                [(ngModel)]="formData.acc_ifs_code"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner" />
              <label for="acc_ifs_code"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">IFS
                Code</label>
            </div>
          </div>
          <!-- Other Information -->
          <div class="col-span-1">
            <div class="relative">
              <textarea rows="3" id="acc_other_info" name="acc_other_info" placeholder=" "
                [(ngModel)]="formData.acc_other_info" class="block px-1 py-2 w-full text-[13px] text-383838 font-normal
            bg-white rounded-md border border-d9d9d9 appearance-none !bg-none
            focus:outline-none focus:ring-0 focus:border-c19725
            peer resize-none"></textarea>

              <label for="acc_other_info" class="absolute text-[13px] text-9ca0a9 duration-300 transform
            -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1
            peer-focus:text-c19725
            peer-placeholder-shown:scale-100
            peer-placeholder-shown:translate-y-0
            peer-placeholder-shown:top-3
            peer-focus:top-2
            peer-focus:scale-75
            peer-focus:-translate-y-4
            start-1">
                Other Information
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- SUBMIT BUTTON -->
  <div class="mt-6 mb-4 flex items-center justify-center gap-2 sm:gap-3">
    <button type="button" (click)="onSubmit(false)"
      class="w-full sm:w-48 px-2 sm:px-4 py-2 cursor-pointer rounded-md bg-018f37 border border-018f37 text-white text-sm sm:text-base font-medium hover:bg-green-700 hover:shadow-lg transition-all duration-200">
      {{ accountId ? 'Update' : 'Save → ADD MORE' }}
    </button>
    <button type="button" (click)="onSubmit(true)"
      class="w-full sm:w-48 px-2 sm:px-4 py-2 cursor-pointer rounded-md bg-white border border-018f37 text-018f37 text-sm sm:text-base font-medium hover:shadow-lg transition-all duration-200">
      {{ accountId ? 'Update & LIST' : 'Save → LIST' }}
    </button>
    @if (accountId) {
    <button type="button" (click)="onDelete()"
      class="w-full sm:w-48 px-2 sm:px-4 py-2 cursor-pointer rounded-md bg-red-600 border border-red-600 text-white text-sm sm:text-base font-medium hover:bg-red-700 hover:shadow-lg transition-all duration-200">
      Delete
    </button>
    }
  </div>


</form>